export const COOKIES_MAX_AGE = 60 * 60 * 24 * 365; // 1 year in seconds
